module.exports = __webpack_public_path__ + "assets/pressurized-pumping-station.18c37f63.svg";